
import React, { useState, useEffect } from 'react';
import axios from '../../utils/fvAxios';
import { TextField, TextareaAutosize, Typography, Button, Select, MenuItem, Checkbox, ListItemText, Stack, } from '@mui/material';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import apiinfo from "../../utils/base-uri.json";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CloseIcon from '@mui/icons-material/Close';
import { HasPermissions } from '../../utils/Token';
import INFO from "../../utils/Enums.json";

export default function NewVendor() {

    const menuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: "320px",
            },

        },
    };

    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [EmailErr, setEmailErr] = useState("");
    const [zipErr, setZipErr] = useState("");

    const [clientList, setClientList] = React.useState([]);
    const [LocationsList, setLocationsList] = React.useState([]);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [Languages, setLanguages] = React.useState([]);
    const [RisklevelList, setRisklevelList] = React.useState([]);
    const [CCandBCCInfo, setCCandBCCInfo] = useState([]);
    const [VendorTypeList, setVendorTypeList] = React.useState([]);

    const [clientId, setClientId] = React.useState("");
    const [LocationsListIds, setLocationsListIds] = useState([]);
    const [VendorCompanyName, setVendorCompanyName] = useState("");
    const [Firstname, setFirstname] = useState("");
    const [LastName, setLastName] = useState("");
    const [Email, setEmail] = useState("");
    const [counrtyid, setCounrtyid] = useState("");
    const [stateid, setStateid] = useState("");
    const [City, setCity] = useState("");
    const [Address1, setAddress1] = useState("");
    const [Address2, setAddress2] = useState("");
    const [Address3, setAddress3] = useState("");
    const [zip, setZip] = useState("");
    const [Language, setLanguage] = useState("");
    const [RisklevelId, setRisklevelId] = React.useState("");
    const [VendorTypeId, setVendorTypeId] = React.useState("");
    const [comments, setComments] = React.useState("");
    const [CCID, setCCID] = useState([]);
    const [MySelfCC, setMySelfCC] = useState(false);
    const [BCCID, setBCCID] = useState([]);
    const [MySelfBCc, setMySelfBCc] = useState(false);

    const [state, setSate] = useState(false);
    const [open, setOpen] = useState(false);
    const [RiskComments, setRiskComments] = useState("");
    const [RiskName, setRiskName] = useState("");
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        Details();
    }, []);

    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
        ChangeClients(res?.data?.data[0]?.value);

        // const resp = await axios.get("Client/GetLanguages");
        // setLanguages(resp?.data?.data);

    }
    const ChangeClients = async (i) => {
        setClientId(i);
        const res = await axios.get("Common/GetLocationsByClientId?clientId=" + i);
        setLocationsList(res?.data?.data);

        const resp = await axios.get("Common/GetRiskLevelWithDetailsByClientId?clientId=" + i);
        setRisklevelList(resp?.data?.data);

        const response = await axios.get("MyAccount/GetCCAndBCCListForEmailVendor?orgID=" + i);
        setCCandBCCInfo(response?.data?.data);

        const re = await axios.post("/Client/GetClientContractTypes?clientId=" + i);
        setVendorTypeList(re?.data?.data?.item2);

    }


    const ChangeEmail = (e) => {
        let regEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,20})[ ]*$/i;

        if (e == "") {
            setEmail(e);
            setEmailErr("");
        } else if (!regEmail.test(e)) {
            setEmail(e);
            setEmailErr("Please check email format");
        } else {
            setEmail(e);
            setEmailErr("");
        }
    }



    useEffect(() => {
        axios.get(apiinfo.addressInfo.getCountries)
            .then((res) => {
                if (res?.data?.responseCode === 100) {
                    setCountries(res?.data?.data)
                    getState(res?.data?.data[0]?.value);
                }
            }).catch(err => {
                console.log(err)
            })
    }, []);

    const ChangeRisklevel = (e) => {
        const Details = RisklevelList?.find((r) => r?.clientTemplateId == e);
        if (Details?.isLocked == true) {
            setRisklevelId(Details?.clientTemplateId);
            setRiskName(Details?.risk);
            setRiskComments(Details?.lockComments)
            handleClickOpen();
        } else {
            setRisklevelId(Details?.clientTemplateId);
            setRiskName(Details?.risk);
        }
    }

    const getState = (e) => {
        setCounrtyid(e);
        axios.get(apiinfo.addressInfo.getStateByRegion + "clientID=" + 0 + "&country=" + e)
            .then((res) => {
                if (res?.data?.responseCode === 100) {
                    setStates(res?.data?.data);
                    setStateid(res?.data?.data[0]?.value);
                }
            }).catch(err => {
                console.log(err)
            })
        if (e == "Not Applicable")
            setLanguages([]);
        axios.get("Common/GetCountryLanguages?country=" + e)
            .then((res) => {
                if (res?.data?.responseCode === 100) {
                    setLanguages(res?.data?.data);
                    setLanguage(res?.data?.data[0]?.key);
                }
            }).catch(err => {
                console.log(err)
            })

    }
    const handleClickOpen = (num, r) => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const ChangeZip = (e) => {
        if (e == "") {
            setZipErr("");
            setZip(e);
        } else if (e != "" && e.length > 10) {
            setZipErr("Check  Zip/Postal Code");
            setZip(e);
        } else {
            setZipErr("")
            setZip(e);
        }

    }
    const Clear = () => {
        setLocationsListIds([]);
        setVendorCompanyName("");
        setFirstname("");
        setLastName("");
        setEmail("");
        //setCounrtyid("");
        //setStateid("")
        getState(countries[0]?.value);
        setCity("");
        setAddress1("");
        setAddress2("");
        setAddress3("");
        setZip("");
        // setLanguage("");
        setRisklevelId("");
        setVendorTypeId("");
        setComments("");
        setCCID([]);
        setMySelfCC(false);
        setBCCID([]);
        setMySelfBCc(false);
    }

    // "hasPrevious": false,
    //         "hasNext": false,
    //         "pageNumber": 0,
    const onSubmit = async () => {
        setSate(true);
        const newDate = Date();
        const CurrentDate = new Date(newDate).toISOString();
        //"2023-08-23T07:30" 
        const Data = {
            "client": clientId,
            "location": LocationsListIds,
            "fullName": Firstname,
            "emailAddress": Email,
            "isSendBCC": MySelfBCc,
            "isSendMeCC": MySelfCC,
            "usersSendCC": CCID,
            "usersSendBCC": BCCID,
            "lastName": LastName,
            "clientCode": null,
            "address1": Address1,
            "address2": Address2,
            "address3": Address3,
            "city": City,
            "state": stateid,
            "zip": zip,
            "country": counrtyid,
            "invitationId": "00000000-0000-0000-0000-000000000000",
            "userEmail": null,
            "vendorCompanyName": VendorCompanyName,
            "riskLevel": RiskName,
            "comments": comments,
            "invitationType": 3,
            "invitationDate": CurrentDate,
            "vendorId": 0,
            "language": Language,
            "invitationCode": null,
            "clientContractId": VendorTypeId == "" ? 0 : VendorTypeId
        }

        axios.post("AdminVendors/PostVendorInvite", Data)
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    toastNotify(res?.data?.responseMessage, true);
                    Clear();
                    setSate(false);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setSate(false);

            });


    };

    return (
        <>
            <ToastContainer />
            <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                <DialogContent sx={{ padding: "48px 48px" }}>
                    <Stack direction={"row"} spacing={"Auto"}>
                        <DialogTitle sx={{ fontSize: "30px" }}> {RiskName} </DialogTitle>
                        <Button color="error" onClick={() => {
                            handleClose();
                            setRisklevelId("");
                        }} sx={{ textTransform: "capitalize" }}><CloseIcon /></Button>
                    </Stack>
                    <hr />
                    <DialogActions >
                        <div>
                            <div dangerouslySetInnerHTML={{ __html: RiskComments }} />
                            <br />
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox checked={checked} onChange={(e) => setChecked(e?.target?.checked)} size="medium" style={{ marginLeft: "5px", text: "red" }} />}
                                    label="I Understand."
                                />
                            </FormGroup>
                            <DialogActions >
                                <div className="login-help__buttonContainer mt-4">
                                    <Button variant="contained" className="login-button-request mx-2" onClick={() => {
                                        if (checked == true) {
                                            handleClose();
                                            setChecked(false);
                                        } else {
                                            toastNotify("Please Read The Comments", false);
                                        }
                                    }} >Done</Button>
                                </div>
                            </DialogActions>
                        </div >
                    </DialogActions>



                </DialogContent>
            </Dialog>

            <Box sx={{ backgroundColor: 'white' }}>
                <div className='mx-3'>
                    <span style={{ color: "red" }}>This tab is for inviting vendors that are not currently registered for your company in FIRST, VERIFY. If you don't know whether or not a vendor is already registered for your company, please look under <a href='/VendorSearch' style={{ textDecoration: "none", color: "#2A93DB" }}> Vendor Search</a> before sending an invitation.</span>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Client <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            labelId="demo-multiple-name-label"
                            value={clientId || ""}
                            id="demo-multiple-name"
                            size="small"
                            onChange={(e) => ChangeClients(e.target.value)}
                            MenuProps={menuProps}
                        >
                            {clientList?.map((r, i) =>
                                <MenuItem key={i} value={r?.value} > {r?.text}</MenuItem>
                            )}
                        </Select>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Location <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <Select
                            labelId="docs-label"
                            id="docs-select"
                            multiple
                            size='small'
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            name="Site Safety Representive"
                            value={LocationsListIds || []}
                            MenuProps={menuProps}
                            renderValue={(selected) =>
                                selected
                                    .map((value) => LocationsList?.find((doc) => doc?.value === value)?.key)
                                    .filter((text) => text !== undefined)
                                    .join(", ")
                            }
                            onChange={(e) => setLocationsListIds(e.target.value)}
                        >
                            <MenuItem key="Select All" hidden={LocationsList?.length == 0}>

                                <Checkbox
                                    id="select-all-checkbox"
                                    indeterminate={
                                        LocationsListIds?.length > 0 && LocationsListIds?.length < LocationsList?.length
                                    }
                                    checked={LocationsListIds?.length === LocationsList?.length}
                                    onChange={(event) => {
                                        if (event?.target?.checked) {
                                            setLocationsListIds(LocationsList?.map((doc) => doc?.value));
                                        } else {
                                            setLocationsListIds([]);
                                        }
                                    }}
                                />
                                <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                    Select All
                                </label>
                            </MenuItem>
                            {LocationsList?.map((r, i) => (
                                <MenuItem key={i} value={r?.value}>
                                    <Checkbox checked={LocationsListIds?.indexOf(r?.value) > -1} />
                                    <ListItemText primary={r?.key} />

                                </MenuItem>
                            ))}
                        </Select>

                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Vendor Company Name <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}

                            type="text"
                            id="Vendor Company Name"
                            name="Vendor Company Name"
                            value={VendorCompanyName || ""}
                            placeholder="Vendor Company Name"
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => setVendorCompanyName(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-4 ">
                        <span className="input-label-right"> First Name <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}
                            size='small'

                            id="first Name"
                            name="first Name"
                            value={Firstname || ""}
                            placeholder="First Name"
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => setFirstname(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right"> Last Name <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}

                            id="last Name"
                            name="last Name"
                            placeholder="Last Name"
                            size='small'
                            value={LastName || ""}
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => setLastName(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3 ">
                        <span className="input-label-right"> Email Address<small style={{ color: "red" }}>*</small> </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}
                            id="email"
                            name="email"
                            value={Email || ""}
                            placeholder="Email Address"
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => ChangeEmail(e.target.value)}
                        />
                        <br></br>
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {EmailErr}
                        </Typography>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Country </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            labelId="counrty"
                            value={counrtyid || ""}
                            id="counrty"
                            size="small"
                            MenuProps={menuProps}
                            onChange={(e) => getState(e.target.value)}
                        >
                            {countries?.map((item, index) => (
                                <MenuItem key={index} value={item?.value}>
                                    {item?.value}
                                </MenuItem>
                            ))}
                        </Select>

                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">State or Province </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            labelId="state"
                            id="state"
                            size="small"
                            value={stateid || ""}
                            MenuProps={menuProps}
                            onChange={(e) => setStateid(e.target.value)}
                        >
                            {states?.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2' >
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">City  </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}

                            id="City"
                            name="City"
                            placeholder="City"
                            size='small'
                            value={City || ""}
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => setCity(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2' >
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Address Line 1 </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}

                            id="Address Line 1"
                            name="Address Line 1"
                            placeholder="Address Line 1"
                            size='small'
                            value={Address1 || ""}
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => setAddress1(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2' >
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Address Line 2  </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}

                            id="Address Line 2"
                            name="Address Line 2"
                            placeholder="Address Line 2"
                            size='small'
                            value={Address2 || ""}
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => setAddress2(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2' >
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Address Line 3  </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}

                            id="Address Line 3"
                            name="Address Line 3"
                            placeholder="Address Line 3"
                            size='small'
                            value={Address3 || ""}
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => setAddress3(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3 ">
                        <span className="input-label-right">Zip/Postal Code </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}
                            required
                            id="zip"
                            name="zip"
                            placeholder="Zip/Postal Code"
                            size='small'
                            value={zip || ""}
                            onChange={(e) => ChangeZip(e.target.value)}
                            className="form-control text-feild-custom mx-2"
                        />
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Select Language </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            labelId="Language"
                            id="Language"
                            size="small"
                            MenuProps={menuProps}
                            value={Language}
                            onChange={(e) => setLanguage(e.target.value)}
                        >
                            {Languages?.map((item, index) => (
                                <MenuItem key={index} value={item?.key}>
                                    {item?.value}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Risk Level <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            labelId="Language"
                            id="Language"
                            size="small"
                            MenuProps={menuProps}
                            value={RisklevelId}
                            onChange={(e) => ChangeRisklevel(e.target.value)}
                        >
                            {RisklevelList?.map((item, index) => (
                                <MenuItem key={index} value={item?.clientTemplateId}>
                                    {item?.risk}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Vendor Type</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <Select
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            labelId="demo-multiple-name-label"
                            value={VendorTypeId || ""}
                            id="demo-multiple-name"
                            size="small"
                            onChange={(e) => setVendorTypeId(e.target.value)}
                            MenuProps={menuProps}
                            disabled={VendorTypeList?.length == 0}
                        >
                            {VendorTypeList?.map((r, i) =>
                                <MenuItem key={i} value={r?.key} > {r?.value}</MenuItem>
                            )}
                        </Select>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' hidden={VendorTypeList?.length == 0} />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right"> Comments </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <TextareaAutosize
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px"
                            }}
                            minRows={3}
                            id="additionalDescription"
                            name="additionalDescription"
                            placeholder="Comments"
                            size='small'
                            value={comments || ""}
                            className="form-control text-feild-custom mx-2"
                            onChange={(e) => setComments(e.target.value)}
                        />
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Send via CC to</span><br />
                        <Stack direction={"row"} spacing={2}>
                            <span className="input-label-right text-muted" >Myself</span>
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox checked={MySelfCC} onChange={(e) => setMySelfCC(e.target.checked)} size="medium" />}
                                />
                            </FormGroup>
                        </Stack>

                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">

                        <Select
                            labelId="docs-label"
                            id="docs-select"
                            multiple
                            size='small'
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            name="Site Safety Representive"
                            value={CCID || []}
                            MenuProps={menuProps}
                            renderValue={(selected) =>
                                selected
                                    .map((key) => CCandBCCInfo?.find((doc) => doc?.key === key)?.value)
                                    .filter((value) => value !== undefined)
                                    .join(", ")
                            }
                            onChange={(e) => setCCID(e.target.value)}
                        >

                            <MenuItem key="Select All">
                                <Checkbox
                                    id="select-all-checkbox"
                                    indeterminate={
                                        CCID?.length > 0 && CCID?.length < CCandBCCInfo?.length
                                    }
                                    checked={CCID?.length === CCandBCCInfo?.length}
                                    onChange={(event) => {
                                        if (event?.target?.checked) {
                                            setCCID(CCandBCCInfo?.map((doc) => doc?.key));
                                        } else {
                                            setCCID([]);
                                        }
                                    }}
                                />
                                <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                    Select All
                                </label>
                            </MenuItem>
                            {CCandBCCInfo?.map((r, i) => (
                                <MenuItem key={i} value={r?.key}>
                                    <Checkbox checked={CCID?.indexOf(r?.key) > -1} />
                                    <ListItemText primary={r?.value} />

                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                        <span className="input-label-right">Send via BCC to</span>
                        <Stack direction={"row"} spacing={2}>
                            <span className="input-label-right text-muted" >Myself</span>
                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox checked={MySelfBCc} onChange={(e) => setMySelfBCc(e.target.checked)} size="medium" />}
                                />
                            </FormGroup>
                        </Stack>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">

                        <Select
                            labelId="docs-label"
                            id="docs-select"
                            multiple
                            size='small'
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: "410px",
                                marginLeft: "8px"
                            }}
                            name="Site Safety Representive"
                            value={BCCID || []}
                            MenuProps={menuProps}
                            renderValue={(selected) =>
                                selected
                                    .map((key) => CCandBCCInfo?.find((doc) => doc?.key === key)?.value)
                                    .filter((value) => value !== undefined)
                                    .join(", ")
                            }
                            onChange={(e) => setBCCID(e.target.value)}
                        >
                            <MenuItem key="Select All">
                                <Checkbox
                                    id="select-all-checkbox"
                                    indeterminate={
                                        BCCID?.length > 0 && BCCID?.length < CCandBCCInfo?.length
                                    }
                                    checked={BCCID?.length === CCandBCCInfo?.length}
                                    onChange={(event) => {
                                        if (event?.target?.checked) {
                                            setBCCID(CCandBCCInfo?.map((doc) => doc?.key));
                                        } else {
                                            setBCCID([]);
                                        }
                                    }}
                                />
                                <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                    Select All
                                </label>
                            </MenuItem>
                            {CCandBCCInfo?.map((r, i) => (
                                <MenuItem key={i} value={r?.key}>
                                    <Checkbox checked={BCCID?.indexOf(r?.key) > -1} />
                                    <ListItemText primary={r?.value} />

                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 block">
                    </div>
                </div>
                <Divider className='mt-3' />

                <div className='row mt-3 mb-3'>
                    <div className='text-right'>
                        {HasPermissions(INFO?.Screens?.InviteVendor, INFO?.ScreenPermissions?.Modify) && <Button
                            disabled={state == true}
                            variant="contained"
                            color="primary"
                            sx={{ padding: "15px", textTransform: "capitalize" }}
                            onClick={onSubmit}
                        >
                            Send Invitation
                        </Button>
                        }
                    </div>
                </div>

            </Box>
        </>
    )
}
